import { arrayOf, number, oneOf, shape, string } from "prop-types";

import addressProps from "./addressProps";
import listingProviderProps from "./listingProviderProps";

export default {
  id: string,
  url: string,
  landlord_id: string,
  address: shape(addressProps),
  allowed_listing_providers: arrayOf(shape(listingProviderProps)),
  active_rentals_count: number,
  neighborhood_rentals_url: string,
  __typename: oneOf(["Building"])
};
